"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectedProducts = void 0;
const react_1 = require("react");
const ramda_1 = require("ramda");
const react_redux_1 = require("react-redux");
const store_1 = require("../../store");
const useSelectedProducts = ({ lastSelectedRowId, setLastSelectedRowId, products = [], }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const isExclusionModeOn = (0, store_1.useIsExclusionModeOn)();
    const selectedProductIds = (0, store_1.useSelectedProductIds)();
    const total = (0, store_1.useProductsTotal)();
    const selectedProductsForPage = (0, react_1.useMemo)(() => {
        const [selectedProducts, excludedProducts] = (0, ramda_1.partition)(({ id }) => selectedProductIds.includes(id), products);
        if (isExclusionModeOn)
            return excludedProducts;
        return selectedProducts;
    }, [isExclusionModeOn, products, selectedProductIds]);
    const selectedProductsCount = (0, react_1.useMemo)(() => (isExclusionModeOn ? total - selectedProductIds.length : selectedProductIds.length), [isExclusionModeOn, selectedProductIds.length, total]);
    const shouldProductsBeSelected = (0, react_1.useMemo)(() => (selectedProductsForPage.length > 0 && isExclusionModeOn) || (selectedProductsForPage.length === 0 && !isExclusionModeOn), [isExclusionModeOn, selectedProductsForPage.length]);
    const handleAllProductsSelect = (0, react_1.useCallback)(() => {
        setLastSelectedRowId(null);
        const productIds = products.map(({ id }) => id);
        if (shouldProductsBeSelected) {
            dispatch((0, store_1.setSelectedProducts)(productIds));
        }
        else {
            dispatch((0, store_1.clearSelectedProducts)(productIds));
        }
    }, [products, shouldProductsBeSelected]);
    const handleProductSelect = (0, react_1.useCallback)((event, { id }) => {
        const isShiftKeyPressed = event.nativeEvent.shiftKey;
        if (isShiftKeyPressed) {
            const lastSelectedIndex = products.findIndex((it) => it.id === lastSelectedRowId);
            const selectedIndex = products.findIndex((it) => it.id === id);
            if (lastSelectedIndex !== -1) {
                const start = lastSelectedIndex > selectedIndex ? selectedIndex : lastSelectedIndex;
                const end = lastSelectedIndex > selectedIndex ? lastSelectedIndex : selectedIndex;
                const range = products.filter((_, ind) => ind >= start && ind <= end).map((it) => it.id);
                dispatch((0, store_1.addSelectedProductIds)(range));
            }
            else {
                setLastSelectedRowId(id);
                dispatch((0, store_1.addSelectedProductId)(id));
            }
        }
        else {
            setLastSelectedRowId(id);
            dispatch((0, store_1.addSelectedProductId)(id));
        }
    }, [lastSelectedRowId, products]);
    return {
        handleAllProductsSelect,
        handleProductSelect,
        selectedProductsForPage,
        selectedProductsCount,
    };
};
exports.useSelectedProducts = useSelectedProducts;
